import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import { getIn } from 'formik'
import ActionText from '../../../../../../components/ActionText'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'

import { getFormikFieldError } from '../../../../../../helpers/errors'

import { breakdownOptions, BREAKDOWNS } from '../../fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const BreakdownSection = ({ formik }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()
  const { t } = useTranslation()

  const { values, status, errors } = formik

  const [showSecondBreakdown, setShowSecondBreakdown] = useState(false)

  const firstBreakdown = getIn(values, `${BREAKDOWNS}[0]`)
  const secondBreakdown = getIn(values, `${BREAKDOWNS}[1]`)

  const filteredSecondBreakdownOptions = breakdownOptions.filter(option => option.value !== firstBreakdown)

  const showSecondBreakdownDropdownHandler = useCallback(() => {
    setShowSecondBreakdown(true)
  }, [])

  const breakdownsError = getFormikFieldError(errors, status, BREAKDOWNS).error

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Breakdowns')}</h3>

      <Field
        name={`${BREAKDOWNS}[0]`}
        formik={formik}
        options={breakdownOptions}
        placeholder="Breakdown"
        isClearable={true}
      />
      {breakdownsError && breakdownsError[0].includes(`"${firstBreakdown}"`) && (
        <ErrorMessage error={breakdownsError} />
      )}
      {!!firstBreakdown && !showSecondBreakdown && (
        <ActionText className={classes.addSecondDropdownButton} onClick={showSecondBreakdownDropdownHandler}>
          + Add another breakdown
        </ActionText>
      )}
      {showSecondBreakdown && (
        <Field
          name={`${BREAKDOWNS}[1]`}
          formik={formik}
          options={filteredSecondBreakdownOptions}
          placeholder="Second breakdown"
          isClearable={true}
        />
      )}
      {breakdownsError && breakdownsError[0].includes(`"${secondBreakdown}"`) && (
        <ErrorMessage error={breakdownsError} />
      )}
    </section>
  )
}

export default BreakdownSection
